export const languageDisplayNames = {
  en: "English",
  ja: "日本語",
};
